export const registrationCategoryStatus = (value) => {
    switch (value) {
        case "human_status_closed":
            return "Closed";
        case "human_status_open":
            return "Open";
        case "human_status_full":
            return "Full";
        case "human_status_waiting_list":
            return "Waiting List";
        case "human_status_inactive":
            return "Inactive";
        default:
            return "Unknown";
    }
};



// WEBPACK FOOTER //
// ./src/Assets/components/RegistrationCategories/filters/registration_category_status.js